const skills = [
    {
        name: "html5",
        title: "HTML5",
        url: 'https://www.w3.org/TR/html52/',
        featured: true
    },
    {
      name: "css3",
      title: "CSS3",
      url: 'https://www.w3.org/Style/CSS/',
      featured: true
    },
    {
      name: "javascript",
      title: "JavaScript",
      url: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
      featured: true
    },


    {
      name: "mysql",
      title: "MySQL",
      url: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
      featured: true
    },
    {
      name: "mongodb",
      title: "MongoDB",
      url: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
      featured: true
    },
    {
      name: "react",
      title: "React",
      url: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
      featured: true
    },


    {
      name: "graphql",
      title: "GraphQL",
      url: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
      featured: true
    },
    {
      name: "handlebars",
      title: "Handlebars",
      url: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
      featured: true
    },


    {
      name: "bootstrap",
      title: "bootstrap",
      url: 'https://getbootstrap.com/',
      featured: true
    },
    {
      name: "bulma",
      title: "Bulma",
      url: 'https://bulma.io/',
      featured: true
    },
    {
      name: "jquery",
      title: "JQuery",
      url: 'https://jquery.com/',
      featured: true
    },
    {
      name: "nodejs",
      title: "NodeJS",
      url: 'https://nodejs.org/en/about/',
      featured: true
    },
    {
      name: "github",
      title: "GitHub",
      url: 'https://github.com/',
      featured: true
    },
    {
      name: "photoshop",
      title: "Photoshop",
      url: 'https://www.adobe.com/products/photoshop.html',
      featured: true
    },
    {
      name: "illustrator",
      title: "Illustrator",
      url: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
      featured: true
    }
];

export default skills;